import { Link, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen flex-col bg-background-100">
      <Navbar />
      <main className="mx-auto flex w-full max-w-6xl flex-1 flex-col items-center justify-center px-4 py-24 text-center">
        <span className="flex h-20 w-20 items-center justify-center rounded-full bg-primary-100 text-primary-600">
          <i className="ri-compass-discover-line text-4xl"></i>
        </span>
        <p className="mt-6 font-heading text-5xl text-foreground-950">404</p>
        <h1 className="mt-3 font-heading text-xl text-foreground-900">这个页面不存在或已被移除</h1>
        <p className="mt-2 text-sm text-foreground-500">
          你访问的地址是 <span className="font-mono text-foreground-600">{location.pathname}</span>
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm text-background-50 hover:bg-primary-600 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
          <Link
            to="/category/全部"
            className="inline-flex items-center gap-2 rounded-md border border-background-300 px-6 py-3 text-sm text-foreground-700 hover:border-primary-400 hover:text-primary-600 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-apps-2-line"></i>
            浏览全部漫画
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}